import { AlarmDefinitionState } from './types'

export const state: AlarmDefinitionState = {
  alarmDefinitions: [],
  alarmDefinitionOptions: [],
}
